import { create } from "zustand";
import { articleLine } from "pages/mag-home-management/type";

type ArticleLinesTabStore = {
  articlesModalData?: articleLine;
  setArticlesModalData: (data?: articleLine) => void;
};

export const useArticleLinesTabStore = create<ArticleLinesTabStore>((set) => {
  return {
    articlesModalData: undefined,
    setArticlesModalData: (data?: articleLine) => {
      set({ articlesModalData: data });
    },
  };
});
